import { Link } from "react-router-dom";
import clsx from "clsx";

import styles from "./NotFound.module.scss";

const NotFound = () => (
  <main className={styles.notFound}>
    <div className={clsx("container", styles.notFound__container)}>
      <div className={styles.notFound__content}>
        <p className={styles.notFound__code}>404</p>
        <h1 className={styles.notFound__title}>Страница не найдена</h1>
        <Link className={styles.notFound__link} to="/">
          Вернуться на главную
        </Link>
      </div>
    </div>
  </main>
);

export default NotFound;
